export default "__VITE_ASSET__CmmTT1yt__"